import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import english from './en/en.json';
import russian from './ru/ru.json';
import { getLcs } from 'src/utils';
import { ENUM_LOCALSTORAGE } from '../enums/enums';

const resources = {
  en: { translation: english },
  ru: { translation: russian }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getLcs(ENUM_LOCALSTORAGE.lang, 'ru'), // default language
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
